//TODO: see about using a interceptor option with a custom interceptor for these calls to handle the headers for example

import angular from "angular";
import $ from 'jquery';

angular
    .module('api-sentinel')
    .factory('SentinelAuthenticationService', SentinelAuthenticationService);

SentinelAuthenticationService.$inject = ['$http', 'SENTINEL_API_HOST_CONSTANTS'];

export function SentinelAuthenticationService($http, HOST) {
    var apiHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    };

    var service = {
        login: login,
        refresh: refresh,
        logout: logout
    };

    return service;

    function login(username, password) {
        return $http.post(
            HOST.URL + '/auth/web/login',
            $.param({
                client_id: username,
                client_secret: password
            }),
            {
                headers: apiHeaders,
                withCredentials: true
            });
    }

    function refresh() {
        return $http.post(
            HOST.URL + '/auth/web/refresh',
            null,
            {withCredentials: true}
        );
    }

    function logout() {
        return $http.post(
            HOST.URL + '/auth/web/logout',
            null,
            {withCredentials: true}
        );
    }
}
